import React, { useState, useRef } from 'react';
import axios from 'axios'
import './ChatBot.css';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function ChatBot(){

  const [msg, setMsg] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);


  const sendMsg = async () => {
    if (!input.trim()) return; //.trim() -> remove blank spaces

    const newMsg = [...msg, {role:'user', text:input}];
    setMsg(newMsg);
    setInput('');
    setLoading(true);

    try {
      const res = await axios.post('/api/chat', {
        message:input,
        page:'patho',
      });
      setMsg([...newMsg, {role:'bot', text:res.data.reply}]);
    } catch(err){
      console.error(err)
    }finally{
      setLoading(false)
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMsg();
    }
  };

return (
  <div className="chatbot-container">
      <div className="chatbot-header">
        <h3>ChatBot</h3>
      </div>
      <div className="chat-window">
        {msg.map((msg, i) => (
          <div key={i} className={`message ${msg.role}`}>
            <div className="bubble">
              <ReactMarkdown>
                {msg.text}
              </ReactMarkdown>
            </div>
          </div>
        ))}
        {loading && <div className="loading">Bot is typing...</div>}
      </div>

      <div className="chat-input">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type a message..."
        />
        <button onClick={sendMsg}>Send</button>
      </div>
    </div>
  );
};

